import { Component, OnInit } from '@angular/core';
import {UserService} from '../../services/user.service';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {CustomValidators} from '../../core/helper/validators';
import {SetPassword} from '../../api/models/set-password';
import {ToastService} from '../../services/toast.service';
import {ModalController} from '@ionic/angular/lazy';

@Component({
  standalone: false,
  selector: 'app-password-change',
  templateUrl: './password-change.component.html',
  styleUrls: ['./password-change.component.scss'],
})
export class PasswordChangeComponent implements OnInit {

  passwordChangeForm: FormGroup;

  constructor(private userService: UserService,
              public formBuilder: FormBuilder,
              private toast: ToastService,
              private modal: ModalController,
  ) {
    this.passwordChangeForm = this.formBuilder.group({
      current_password: ['', [Validators.minLength(8)]],
      password: ['', [Validators.minLength(8)]],
      password2: ['', []],
    }, { validators: CustomValidators.checkPasswords});
  }

  ngOnInit() {}

  cancel() {
    this.modal.dismiss(null, 'cancel');
  }

  onChangePassword(){

    this.userService.setPassword(this.passwordChangeForm.value.current_password, this.passwordChangeForm.value.password).subscribe( x=> {
      this.toast.presentToast('Passwort geändert', 'success');
      this.modal.dismiss({});
    }, error => {
      this.toast.readAnyErrorValues(error);
    });

  }

}
